import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { ServicesContext } from 'services/context';
import './videoTools.html';
import './videoTools.scss';

components.preload('wcc-list');

export interface CommentVideoToolsVMConfig {
    commentId: SubscribableOrNullableValue<string>
    videoId: SubscribableOrNullableValue<string>
}

@injectable()
export default class CommentVideoToolsVM {
    private commentId: Subscribable<string | undefined>
    private videoId: Subscribable<string | undefined>

    private isGeneratingTranscript = ko.observable(false);

    labels = labels

    isBusy = ko.pureComputed(() => this.isGeneratingTranscript())

    constructor(
        @inject(wccModules.componentConfig) config: CommentVideoToolsVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.servicesContext) private ctx: ServicesContext
    ) {
        this.commentId = ko.flattenComputed(config.commentId);
        this.videoId = ko.flattenComputed(config.videoId);

        const isReady = ko.pureComputed(() => this.commentId() != undefined && this.videoId() != undefined);

        ko.applyBindingsToNode(info.element, {
            'isVisible': isReady,

            'css': {
                'topic__comment__video-tools': true
            }
        }, this);
    }

    async generateTranscript() {
        if (this.isBusy()) return;

        try {
            const commentId = this.commentId();
            const videoId = this.videoId();

            if (commentId == undefined || videoId == undefined)
                throw new Error(messages.InvalidRequest);

            this.isGeneratingTranscript(true);

            await this.ctx.attachmentsService.queries.generateTranscript(commentId, videoId).post();
        } catch (ex) {
            system.handleError(ex);
        } finally {
            this.isGeneratingTranscript(false);
        }
    }
}